// ── Estilos compartilhados ────────────────────────────────────────────────────

export const inputSx = (ro, pendente = false, erro = false) => ({
  "& .MuiInputLabel-root": { color: erro ? "#f44336" : "var(--ig-t-aaaaaa)", fontWeight: "bold" },
  "& .MuiOutlinedInput-root": {
    backgroundColor: ro ? "var(--ig-f-252525)" : "var(--ig-f-2a2a2a)",
    color: "var(--ig-t-ffffff)",
    "& fieldset": { borderColor: erro ? "#f44336" : pendente ? "#f57c00" : ro ? "var(--ig-b-333333)" : "var(--ig-b-444444)" },
    "&:hover fieldset": { borderColor: erro ? "#f44336" : pendente ? "#f57c00" : ro ? "var(--ig-b-333333)" : "var(--ig-b-888888)" },
  },
  "& input": { color: "var(--ig-t-ffffff)" },
  "& textarea": { color: "var(--ig-t-ffffff)" },
  "& .MuiFormHelperText-root": { color: erro ? "#f44336" : undefined },
});

export const selectSx = (ro, pendente = false) => ({
  width: "100%",
  color: "var(--ig-t-ffffff)",
  backgroundColor: ro ? "var(--ig-f-252525)" : "var(--ig-f-2a2a2a)",
  "& .MuiOutlinedInput-notchedOutline": { borderColor: pendente ? "#f57c00" : ro ? "var(--ig-b-333333)" : "var(--ig-b-444444)" },
  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: pendente ? "#f57c00" : ro ? "var(--ig-b-333333)" : "var(--ig-b-888888)" },
  "& .MuiSvgIcon-root": { color: ro ? "transparent" : "var(--ig-t-ffffff)" },
});

export const accordionSx = {
  backgroundColor: "var(--ig-f-1e1e1e)",
  color: "var(--ig-t-ffffff)",
  mb: 1,
  "&:before": { display: "none" },
  border: "1px solid var(--ig-b-333333)",
  borderRadius: "6px !important",
};

export const accordionSummarySx = {
  backgroundColor: "var(--ig-f-252525)",
  borderRadius: "6px",
  "& .MuiAccordionSummary-content": { my: 0.5 },
  "& .MuiSvgIcon-root": { color: "#1998a8" },
};
